import {
  AdminCreateOrganizationAttrs,
  AdminDeleteOrganizationAttrs,
  AdminLoadCurrentOrganizationAttrs,
  AdminLoadStockDigitalPeople,
  AdminSetCurrentOrganizationAttrs,
  AdminSetDefaultDPs,
  AdminSetOrganizationAttrsError,
  AdminSetStockDigitalPeople,
} from './admin-organization-attrs.actions';
import { AdminOrganizationAttrs } from 'src/app/admin/models/organization.model';
import { AdminOrganizationAttrsApiError } from './admin-organization-attrs.errors';
import { SoulfileProject } from 'src/app/admin/models/soulfile-project.model';
import { createReducer, on } from '@ngrx/store';

export const enum LoadingState {
  INIT = 'INIT',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

export interface ErrorState {
  apiError: AdminOrganizationAttrsApiError;
}

export const getError = (callState: CallState): AdminOrganizationAttrsApiError | null => {
  if ((callState as ErrorState).apiError !== undefined) {
    return (callState as ErrorState).apiError;
  }
  return null;
};

export type CallState = LoadingState | ErrorState;

export interface AdminOrganizationAttrsState {
  currentOrganizationAttrs: AdminOrganizationAttrs;
  defaultDPs: SoulfileProject[];
  stockDPs: string[];
  callState: CallState;
}

const initialState: AdminOrganizationAttrsState = {
  currentOrganizationAttrs: null,
  stockDPs: null,
  callState: LoadingState.INIT,
  defaultDPs: null,
};

export const adminOrganizationAttrsReducer = createReducer(
  initialState,
  on(AdminLoadStockDigitalPeople, (state) => ({ ...state, stockDPs: null })),
  on(AdminSetStockDigitalPeople, (state, { stocks }) => ({ ...state, stockDPs: stocks })),
  on(AdminLoadCurrentOrganizationAttrs, (state) => ({ ...state, callState: LoadingState.LOADING })),
  on(AdminCreateOrganizationAttrs, (state) => ({ ...state, callState: LoadingState.LOADING })),
  on(AdminSetCurrentOrganizationAttrs, (state, { attrs }) => ({
    ...state,
    callState: LoadingState.LOADED,
    currentOrganizationAttrs: attrs,
  })),
  on(AdminSetDefaultDPs, (state, { dps }) => ({ ...state, defaultDPs: dps })),
  on(AdminDeleteOrganizationAttrs, (state) => ({ ...state, callState: LoadingState.LOADING })),
  on(AdminSetOrganizationAttrsError, (state, { error }) => ({
    ...state,
    callState: { apiError: error },
  })),
);
